module.exports = __webpack_public_path__ + "img/broadcast-school-icon3.dbbe7139.png";